import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePlatformAppQuery = createQueryHook(PlatformAppsApiClient.getPlatformApp, {
  queryKey: ['platformApp'],
})
